import { default as _91_46_46_46uri_93FmSYeNXvC5Meta } from "/vercel/path0/pages/[...uri].vue?macro=true";
import { default as searchBIFC2dE21WMeta } from "/vercel/path0/pages/search.vue?macro=true";
import { default as styleguideHzhu7gdkpRMeta } from "/vercel/path0/pages/styleguide.vue?macro=true";
export default [
  {
    name: "uri___aplus_de",
    path: "/:uri(.*)*",
    component: () => import("/vercel/path0/pages/[...uri].vue")
  },
  {
    name: "uri___aplus_en",
    path: "/:uri(.*)*",
    component: () => import("/vercel/path0/pages/[...uri].vue")
  },
  {
    name: "uri___aplus_fr",
    path: "/:uri(.*)*",
    component: () => import("/vercel/path0/pages/[...uri].vue")
  },
  {
    name: "uri___aplus_it",
    path: "/:uri(.*)*",
    component: () => import("/vercel/path0/pages/[...uri].vue")
  },
  {
    name: "uri___ageingsociety_de",
    path: "/:uri(.*)*",
    component: () => import("/vercel/path0/pages/[...uri].vue")
  },
  {
    name: "uri___ageingsociety_fr",
    path: "/:uri(.*)*",
    component: () => import("/vercel/path0/pages/[...uri].vue")
  },
  {
    name: "uri___ord_de",
    path: "/:uri(.*)*",
    component: () => import("/vercel/path0/pages/[...uri].vue")
  },
  {
    name: "uri___ord_en",
    path: "/:uri(.*)*",
    component: () => import("/vercel/path0/pages/[...uri].vue")
  },
  {
    name: "uri___ord_fr",
    path: "/:uri(.*)*",
    component: () => import("/vercel/path0/pages/[...uri].vue")
  },
  {
    name: "uri___ord_it",
    path: "/:uri(.*)*",
    component: () => import("/vercel/path0/pages/[...uri].vue")
  },
  {
    name: "uri___polarresearch_de",
    path: "/:uri(.*)*",
    component: () => import("/vercel/path0/pages/[...uri].vue")
  },
  {
    name: "uri___polarresearch_en",
    path: "/:uri(.*)*",
    component: () => import("/vercel/path0/pages/[...uri].vue")
  },
  {
    name: "uri___polarresearch_fr",
    path: "/:uri(.*)*",
    component: () => import("/vercel/path0/pages/[...uri].vue")
  },
  {
    name: "uri___nsan_de",
    path: "/:uri(.*)*",
    component: () => import("/vercel/path0/pages/[...uri].vue")
  },
  {
    name: "uri___nsan_en",
    path: "/nsan_en/:uri(.*)*",
    component: () => import("/vercel/path0/pages/[...uri].vue")
  },
  {
    name: "uri___nsan_fr",
    path: "/nsan_fr/:uri(.*)*",
    component: () => import("/vercel/path0/pages/[...uri].vue")
  },
  {
    name: "uri___nsan_it",
    path: "/nsan_it/:uri(.*)*",
    component: () => import("/vercel/path0/pages/[...uri].vue")
  },
  {
    name: "uri___prixmedia_de",
    path: "/:uri(.*)*",
    component: () => import("/vercel/path0/pages/[...uri].vue")
  },
  {
    name: "uri___prixmedia_en",
    path: "/:uri(.*)*",
    component: () => import("/vercel/path0/pages/[...uri].vue")
  },
  {
    name: "uri___prixmedia_fr",
    path: "/:uri(.*)*",
    component: () => import("/vercel/path0/pages/[...uri].vue")
  },
  {
    name: "uri___prixmedia_it",
    path: "/:uri(.*)*",
    component: () => import("/vercel/path0/pages/[...uri].vue")
  },
  {
    name: "uri___tdnet_de",
    path: "/:uri(.*)*",
    component: () => import("/vercel/path0/pages/[...uri].vue")
  },
  {
    name: "uri___tdnet_en",
    path: "/:uri(.*)*",
    component: () => import("/vercel/path0/pages/[...uri].vue")
  },
  {
    name: "uri___tdnet_fr",
    path: "/:uri(.*)*",
    component: () => import("/vercel/path0/pages/[...uri].vue")
  },
  {
    name: "uri___tdnet_it",
    path: "/:uri(.*)*",
    component: () => import("/vercel/path0/pages/[...uri].vue")
  },
  {
    name: "uri___youngacademy_de",
    path: "/:uri(.*)*",
    component: () => import("/vercel/path0/pages/[...uri].vue")
  },
  {
    name: "uri___youngacademy_en",
    path: "/:uri(.*)*",
    component: () => import("/vercel/path0/pages/[...uri].vue")
  },
  {
    name: "uri___youngacademy_fr",
    path: "/:uri(.*)*",
    component: () => import("/vercel/path0/pages/[...uri].vue")
  },
  {
    name: "uri___youngacademy_it",
    path: "/:uri(.*)*",
    component: () => import("/vercel/path0/pages/[...uri].vue")
  },
  {
    name: "SearchPage___aplus_de",
    path: "/search",
    meta: searchBIFC2dE21WMeta || {},
    component: () => import("/vercel/path0/pages/search.vue")
  },
  {
    name: "SearchPage___aplus_en",
    path: "/search",
    meta: searchBIFC2dE21WMeta || {},
    component: () => import("/vercel/path0/pages/search.vue")
  },
  {
    name: "SearchPage___aplus_fr",
    path: "/search",
    meta: searchBIFC2dE21WMeta || {},
    component: () => import("/vercel/path0/pages/search.vue")
  },
  {
    name: "SearchPage___aplus_it",
    path: "/search",
    meta: searchBIFC2dE21WMeta || {},
    component: () => import("/vercel/path0/pages/search.vue")
  },
  {
    name: "SearchPage___ageingsociety_de",
    path: "/search",
    meta: searchBIFC2dE21WMeta || {},
    component: () => import("/vercel/path0/pages/search.vue")
  },
  {
    name: "SearchPage___ageingsociety_fr",
    path: "/search",
    meta: searchBIFC2dE21WMeta || {},
    component: () => import("/vercel/path0/pages/search.vue")
  },
  {
    name: "SearchPage___ord_de",
    path: "/search",
    meta: searchBIFC2dE21WMeta || {},
    component: () => import("/vercel/path0/pages/search.vue")
  },
  {
    name: "SearchPage___ord_en",
    path: "/search",
    meta: searchBIFC2dE21WMeta || {},
    component: () => import("/vercel/path0/pages/search.vue")
  },
  {
    name: "SearchPage___ord_fr",
    path: "/search",
    meta: searchBIFC2dE21WMeta || {},
    component: () => import("/vercel/path0/pages/search.vue")
  },
  {
    name: "SearchPage___ord_it",
    path: "/search",
    meta: searchBIFC2dE21WMeta || {},
    component: () => import("/vercel/path0/pages/search.vue")
  },
  {
    name: "SearchPage___polarresearch_de",
    path: "/search",
    meta: searchBIFC2dE21WMeta || {},
    component: () => import("/vercel/path0/pages/search.vue")
  },
  {
    name: "SearchPage___polarresearch_en",
    path: "/search",
    meta: searchBIFC2dE21WMeta || {},
    component: () => import("/vercel/path0/pages/search.vue")
  },
  {
    name: "SearchPage___polarresearch_fr",
    path: "/search",
    meta: searchBIFC2dE21WMeta || {},
    component: () => import("/vercel/path0/pages/search.vue")
  },
  {
    name: "SearchPage___nsan_de",
    path: "/search",
    meta: searchBIFC2dE21WMeta || {},
    component: () => import("/vercel/path0/pages/search.vue")
  },
  {
    name: "SearchPage___nsan_en",
    path: "/nsan_en/search",
    meta: searchBIFC2dE21WMeta || {},
    component: () => import("/vercel/path0/pages/search.vue")
  },
  {
    name: "SearchPage___nsan_fr",
    path: "/nsan_fr/search",
    meta: searchBIFC2dE21WMeta || {},
    component: () => import("/vercel/path0/pages/search.vue")
  },
  {
    name: "SearchPage___nsan_it",
    path: "/nsan_it/search",
    meta: searchBIFC2dE21WMeta || {},
    component: () => import("/vercel/path0/pages/search.vue")
  },
  {
    name: "SearchPage___prixmedia_de",
    path: "/search",
    meta: searchBIFC2dE21WMeta || {},
    component: () => import("/vercel/path0/pages/search.vue")
  },
  {
    name: "SearchPage___prixmedia_en",
    path: "/search",
    meta: searchBIFC2dE21WMeta || {},
    component: () => import("/vercel/path0/pages/search.vue")
  },
  {
    name: "SearchPage___prixmedia_fr",
    path: "/search",
    meta: searchBIFC2dE21WMeta || {},
    component: () => import("/vercel/path0/pages/search.vue")
  },
  {
    name: "SearchPage___prixmedia_it",
    path: "/search",
    meta: searchBIFC2dE21WMeta || {},
    component: () => import("/vercel/path0/pages/search.vue")
  },
  {
    name: "SearchPage___tdnet_de",
    path: "/search",
    meta: searchBIFC2dE21WMeta || {},
    component: () => import("/vercel/path0/pages/search.vue")
  },
  {
    name: "SearchPage___tdnet_en",
    path: "/search",
    meta: searchBIFC2dE21WMeta || {},
    component: () => import("/vercel/path0/pages/search.vue")
  },
  {
    name: "SearchPage___tdnet_fr",
    path: "/search",
    meta: searchBIFC2dE21WMeta || {},
    component: () => import("/vercel/path0/pages/search.vue")
  },
  {
    name: "SearchPage___tdnet_it",
    path: "/search",
    meta: searchBIFC2dE21WMeta || {},
    component: () => import("/vercel/path0/pages/search.vue")
  },
  {
    name: "SearchPage___youngacademy_de",
    path: "/search",
    meta: searchBIFC2dE21WMeta || {},
    component: () => import("/vercel/path0/pages/search.vue")
  },
  {
    name: "SearchPage___youngacademy_en",
    path: "/search",
    meta: searchBIFC2dE21WMeta || {},
    component: () => import("/vercel/path0/pages/search.vue")
  },
  {
    name: "SearchPage___youngacademy_fr",
    path: "/search",
    meta: searchBIFC2dE21WMeta || {},
    component: () => import("/vercel/path0/pages/search.vue")
  },
  {
    name: "SearchPage___youngacademy_it",
    path: "/search",
    meta: searchBIFC2dE21WMeta || {},
    component: () => import("/vercel/path0/pages/search.vue")
  },
  {
    name: "styleguide___aplus_de",
    path: "/styleguide",
    component: () => import("/vercel/path0/pages/styleguide.vue")
  },
  {
    name: "styleguide___aplus_en",
    path: "/styleguide",
    component: () => import("/vercel/path0/pages/styleguide.vue")
  },
  {
    name: "styleguide___aplus_fr",
    path: "/styleguide",
    component: () => import("/vercel/path0/pages/styleguide.vue")
  },
  {
    name: "styleguide___aplus_it",
    path: "/styleguide",
    component: () => import("/vercel/path0/pages/styleguide.vue")
  },
  {
    name: "styleguide___ageingsociety_de",
    path: "/styleguide",
    component: () => import("/vercel/path0/pages/styleguide.vue")
  },
  {
    name: "styleguide___ageingsociety_fr",
    path: "/styleguide",
    component: () => import("/vercel/path0/pages/styleguide.vue")
  },
  {
    name: "styleguide___ord_de",
    path: "/styleguide",
    component: () => import("/vercel/path0/pages/styleguide.vue")
  },
  {
    name: "styleguide___ord_en",
    path: "/styleguide",
    component: () => import("/vercel/path0/pages/styleguide.vue")
  },
  {
    name: "styleguide___ord_fr",
    path: "/styleguide",
    component: () => import("/vercel/path0/pages/styleguide.vue")
  },
  {
    name: "styleguide___ord_it",
    path: "/styleguide",
    component: () => import("/vercel/path0/pages/styleguide.vue")
  },
  {
    name: "styleguide___polarresearch_de",
    path: "/styleguide",
    component: () => import("/vercel/path0/pages/styleguide.vue")
  },
  {
    name: "styleguide___polarresearch_en",
    path: "/styleguide",
    component: () => import("/vercel/path0/pages/styleguide.vue")
  },
  {
    name: "styleguide___polarresearch_fr",
    path: "/styleguide",
    component: () => import("/vercel/path0/pages/styleguide.vue")
  },
  {
    name: "styleguide___nsan_de",
    path: "/styleguide",
    component: () => import("/vercel/path0/pages/styleguide.vue")
  },
  {
    name: "styleguide___nsan_en",
    path: "/nsan_en/styleguide",
    component: () => import("/vercel/path0/pages/styleguide.vue")
  },
  {
    name: "styleguide___nsan_fr",
    path: "/nsan_fr/styleguide",
    component: () => import("/vercel/path0/pages/styleguide.vue")
  },
  {
    name: "styleguide___nsan_it",
    path: "/nsan_it/styleguide",
    component: () => import("/vercel/path0/pages/styleguide.vue")
  },
  {
    name: "styleguide___prixmedia_de",
    path: "/styleguide",
    component: () => import("/vercel/path0/pages/styleguide.vue")
  },
  {
    name: "styleguide___prixmedia_en",
    path: "/styleguide",
    component: () => import("/vercel/path0/pages/styleguide.vue")
  },
  {
    name: "styleguide___prixmedia_fr",
    path: "/styleguide",
    component: () => import("/vercel/path0/pages/styleguide.vue")
  },
  {
    name: "styleguide___prixmedia_it",
    path: "/styleguide",
    component: () => import("/vercel/path0/pages/styleguide.vue")
  },
  {
    name: "styleguide___tdnet_de",
    path: "/styleguide",
    component: () => import("/vercel/path0/pages/styleguide.vue")
  },
  {
    name: "styleguide___tdnet_en",
    path: "/styleguide",
    component: () => import("/vercel/path0/pages/styleguide.vue")
  },
  {
    name: "styleguide___tdnet_fr",
    path: "/styleguide",
    component: () => import("/vercel/path0/pages/styleguide.vue")
  },
  {
    name: "styleguide___tdnet_it",
    path: "/styleguide",
    component: () => import("/vercel/path0/pages/styleguide.vue")
  },
  {
    name: "styleguide___youngacademy_de",
    path: "/styleguide",
    component: () => import("/vercel/path0/pages/styleguide.vue")
  },
  {
    name: "styleguide___youngacademy_en",
    path: "/styleguide",
    component: () => import("/vercel/path0/pages/styleguide.vue")
  },
  {
    name: "styleguide___youngacademy_fr",
    path: "/styleguide",
    component: () => import("/vercel/path0/pages/styleguide.vue")
  },
  {
    name: "styleguide___youngacademy_it",
    path: "/styleguide",
    component: () => import("/vercel/path0/pages/styleguide.vue")
  }
]